import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import ReactTags from "react-tag-autocomplete";

import {
	ADD_GOODDEAL_ORGANIZATION_CHANNEL,
	DELETE_GOODDEAL_ORGANIZATION_CHANNEL
} from "actions/types.js";
import { fetchSearchGooddealOrganizationChannels } from "actions/channel";

// Good deal channels of the organizations of an app: a good deal broadcast on an
// organization reaches every community subscribed to its channel
function OrganizationChannelsField({
	communityType,
	channels,
	suggestions,
	dispatch,
	fetchSearchGooddealOrganizationChannels
}) {
	return (
		<ReactTags
			placeholderText="Organisations ..."
			tags={channels}
			suggestions={suggestions}
			minQueryLength={3}
			maxSuggestionsLength={10}
			onDelete={index => {
				if (index >= 0) {
					dispatch({
						type: DELETE_GOODDEAL_ORGANIZATION_CHANNEL,
						communityType,
						index
					});
				}
			}}
			onAddition={value =>
				dispatch({
					type: ADD_GOODDEAL_ORGANIZATION_CHANNEL,
					communityType,
					value
				})
			}
			suggestionsFilter={() => true}
			onInput={query => {
				if (query?.length > 2) {
					fetchSearchGooddealOrganizationChannels(query, communityType);
				}
			}}
			removeButtonText="Cliquez pour retirer"
			inputAttributes={{
				autoComplete: "new-password"
			}}
		/>
	);
}

OrganizationChannelsField.propTypes = {
	communityType: PropTypes.oneOf(["City", "Campsite", "Neighborhood"])
		.isRequired
};

const mapStateToProps = (state, { communityType }) => {
	const { organization_channels, organization_channels_suggestions } =
		state.gooddealReducer;
	return {
		channels: Object.values(organization_channels[communityType] || {}),
		suggestions: Object.values(
			organization_channels_suggestions[communityType] || {}
		)
	};
};

const mapDispatchToProps = dispatch => ({
	...bindActionCreators({ fetchSearchGooddealOrganizationChannels }, dispatch),
	dispatch
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OrganizationChannelsField);
